var colorGenerator = (index) => {
  const colors = [
    "SlateBlue",
    "Tomato",
    "DarkKhaki",
    "LightSalmon",
    "Thistle",
    "Indigo",
    "SeaGreen",
    "CadetBlue",
    "PaleVioletRed",
    "MediumAquamarine",
    "DeepSkyBlue",
    "Teal",
    "Wheat",
    "SlateGray",
    "RosyBrown",
    "Peru",
  ];
  return colors[index % colors.length];
};

export default { colorGenerator };
